export const LIST_ISSUE_AREA_URL = `issue-areas`


export function getList(axiosPrivate){
  return axiosPrivate.get(LIST_ISSUE_AREA_URL)
}